<ng-container *ngIf="visible">
<dx-popup
  [(visible)]="visible"
  [width]="450"
  [height]="'auto'"
  [showTitle]="true"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  (onHiding)="close()"
  class="custom-popup"
>
  <!-- Başlık -->
  <div *dxTemplate="let popupData of 'title'" class="popup-title" [ngClass]="data?.type">
    <fa-icon
      *ngIf="data?.type === 'error'"
      [icon]="['fas', 'exclamation-triangle']"
      class="title-icon"
    ></fa-icon>
    <fa-icon
      *ngIf="data?.type === 'warning'"
      [icon]="['fas', 'exclamation-circle']"
      class="title-icon"
    ></fa-icon>
    <fa-icon
      *ngIf="data?.type === 'success'"
      [icon]="['fas', 'check-circle']"
      class="title-icon"
    ></fa-icon>
    <fa-icon
      *ngIf="data?.type === 'info'"
      [icon]="['fas', 'info-circle']"
      class="title-icon"
    ></fa-icon>

    <span class="title-text">
      {{data?.title || (data?.type === 'error'
      ? 'Hata'
      : data?.type === 'warning'
        ? 'Uyarı'
        :data?.type === 'success'
        ? 'Başarılı'
        : data?.type === 'info'
          ? 'Bilgi'
          : '' )}}
    </span>
  </div>
<div>
  <span class="subtitle-text">
      {{(data?.type === 'error'
    ? 'Servis hatası'
    : data?.type === 'warning'
      ? 'Validasyon uyarısı'
          : '' )}}
    </span>
  </div>


  <!-- Gövde -->
  <div class="popup-body" [ngClass]="data?.type">
    <div class="popup-message" [innerHTML]="data?.message"></div>
  </div>
  <dx-toolbar class="bottomSaveCancelBtn">
    <dxi-item location="after">
      <dx-button stylingMode="contained" type="danger" text="Tamam"
                 (onClick)="close()">
      </dx-button>
    </dxi-item>
  </dx-toolbar>
</dx-popup>
</ng-container>



